import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=4c6e5992&scoped=true"
import script from "./OverviewPage.vue?vue&type=script&lang=js"
export * from "./OverviewPage.vue?vue&type=script&lang=js"
import style0 from "./OverviewPage.vue?vue&type=style&index=0&id=4c6e5992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e5992",
  null
  
)

export default component.exports